export enum DelfiField {
  ALLERGENS = 'allergens',
  TEMPLATE = 'template',
  PICTOGRAMS = 'pictograms',
  DESCRIPTION_TRANSLATIONS = 'description_translations',
  DISCLAMER_TRANSLATIONS = 'disclamer_translations',
}
